<template>
  <div>
    <a-modal v-model="visible" width="580px" title="编辑用户" ok-text="确认" cancel-text="取消" @ok="submit" @cancel="onCancel">
      <a-form-model ref="modalForm" :model="modalForm" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
        <a-form-model-item label="角色" prop="roles">
          <a-select v-model="modalForm.roles" mode="multiple" style="width: 100%" placeholder="用户角色">
            <a-select-option v-for="role in roleData" :key="role.role_id" :value="role.role_id">{{ role.role_name }}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { userBindRole, roleList } from '@/api/system/auth';
export default {
  name: 'UserModal',
  props: {
    userId: {
      type: [Number, String],
      default: null
    },
    isShow: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      visible: this.isShow,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      projectId: this.$route.params.project_id,
      modalForm: {
        nickname: null,
        phone: null,
        email: null,
        roles: []
      },
      roleData: [],
      rules: {
        roles: [{ required: true, message: '角色不能为空', trigger: 'blur' }]
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        this.getRoleList();
        this.modalForm = {
          ...this.userInfo
        };
      }
    }
  },
  methods: {
    close(type) {
      this.visible = false;
      this.$emit('close', type);
    },

    onCancel() {
      this.utils.trackClick({ name: '取消编辑用户' });
      this.close('cancel');
    },

    getRoleList() {
      roleList({ role_type: 2 }).then(response => {
        this.roleData = response.data.roles;
      });
    },
    submit() {
      this.utils.trackClick({ name: '确认编辑用户' });
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          this.loading = true;
          userBindRole({ id: this.userId, roles: this.modalForm.roles, project_id: this.projectId })
            .then(() => {
              this.$message.success('修改成功');
              this.close('submit');
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
